import Head from 'next/head';
import {Fragment, useMemo} from 'react';
import {STRIPE_ENV, useStripeEnv} from 'mkt-ssr/lib/env';

const PRECONNECTED_DOMAINS: {
  [K in STRIPE_ENV]: Array<string>;
} = {
  [STRIPE_ENV.DEV]: [
    'https://qa-q.stripe.com',
    'https://qa-r.stripe.com',
    'https://images.stripeassets.com',
    'https://assets.stripeassets.com',
  ],
  [STRIPE_ENV.PREPROD]: [
    'https://qa-q.stripe.com',
    'https://qa-r.stripe.com',
    'https://images.stripeassets.com',
    'https://assets.stripeassets.com',
  ],
  [STRIPE_ENV.QA]: [
    'https://qa-q.stripe.com',
    'https://qa-r.stripe.com',
    'https://images.stripeassets.com',
    'https://assets.stripeassets.com',
  ],
  [STRIPE_ENV.PROD]: [
    'https://q.stripe.com',
    'https://r.stripe.com',
    'https://images.stripeassets.com',
    'https://assets.stripeassets.com',
  ],
};

export function Preconnect() {
  const currentEnv = useStripeEnv();
  const domains = useMemo(() => PRECONNECTED_DOMAINS[currentEnv], [currentEnv]);
  const publicPathDomain = useMemo(() => {
    try {
      // eslint-disable-next-line camelcase
      const url = new URL(__webpack_public_path__ || '');
      return url.hostname;
    } catch {
      return undefined;
    }
  }, []);
  return (
    <Head>
      {domains.map((domain) => (
        <Fragment key={domain}>
          <link rel="preconnect" href={domain} crossOrigin="" />
          <link rel="dns-prefetch" href={domain} />
        </Fragment>
      ))}
      {publicPathDomain ? (
        <link rel="preconnect" href={publicPathDomain} crossOrigin="" />
      ) : null}
      {publicPathDomain ? (
        <link rel="dns-prefetch" href={publicPathDomain} />
      ) : null}
    </Head>
  );
}
